import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// storage.drive — the Documents app's full-page Drive (Enhancement 01).
//
// The seeded `ir.action` row (`storage.action_storage_document` in
// `data/storage_menus.xml`) already declares
// `client_component="storage.drive"`; this descriptor is the missing piece
// that binds that identifier to the React component. Vite's eager glob in
// `clientActionsDiscovery.ts` discovers this file at boot.
//
// Phase 1 ships the functional MVP (browse / upload / download / delete);
// the three-pane mockup UX and the per-record dialog surface
// (`open_record_documents`) follow in Phases 2 and 3.
//
// Lazy-loaded so the Drive (+ its TanStack Query hooks) stays out of the
// initial bundle for users who never open Documents.
const DriveBrowser = lazyWithRetry(() => import("../components/DriveBrowser"), "storage.drive");

const plugin: ClientActionDescriptor = {
    key: "storage.drive",
    component: DriveBrowser,
    paramSchema: "any",
};

export default plugin;
